// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__1BvNr","loaderSpinnerBox":"spinner_loaderSpinnerBox__2MX2N"};